import { render, staticRenderFns } from "./AddEditProduct.vue?vue&type=template&id=7b6e81e6&"
import script from "./AddEditProduct.vue?vue&type=script&lang=js&"
export * from "./AddEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports